import { useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { highlightAnim } from './Button.anim';
import S from './Button.module.css';
import { ButtonHTMLAttributes } from 'react';
import { MotionProps } from 'framer-motion';
import Stars from './Stars';

export type ButtonProps = {
  children?: string;
} & MotionProps &
  ButtonHTMLAttributes<HTMLButtonElement>;

const AiButton: FC<ButtonProps> = ({
  children,
  ...rest
}: ButtonProps) => {
  const { t } = useTranslation('activities');
  const label = children ?? t('aiChat.assistantLabel');
  const [hover, setHover] = useState<boolean>(false);

  return (
    <div style={{ position: 'relative' }}>
      <motion.button
        {...rest}
        initial="init"
        animate={hover ? 'anim' : 'init'}
        whileTap="tap"
        onHoverStart={() => setHover(true)}
        onHoverEnd={() => setHover(false)}
        className={S.btn}
        type="button"
      >
        <motion.div
          data-testid="highlight"
          className={S.highlightContainer}
          animate={hover ? 'anim' : 'init'}
        >
          <motion.div variants={highlightAnim} className={S.highlight}></motion.div>
        </motion.div>
        <Stars hover={hover} />
        <span>{label}</span>
      </motion.button>
    </div>
  );
};

export default AiButton;
